module.exports = __webpack_public_path__ + "static/media/etat-repas-blue.e84f81c4.svg";